module.exports = __webpack_public_path__ + "img/DE00492.9f372f03.png";